import { render } from "./ChoiceInput.vue?vue&type=template&id=3f058c36&scoped=true&ts=true"
import script from "./ChoiceInput.vue?vue&type=script&lang=ts"
export * from "./ChoiceInput.vue?vue&type=script&lang=ts"

import "./ChoiceInput.vue?vue&type=style&index=0&id=3f058c36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f058c36"]])

export default __exports__